import { useSteps } from 'hooks/useSteps'

const usePageContent = () => {
  const { current } = useSteps()
  return current || {}
}

export { usePageContent }
